<template>
    <div id="addFollower">
      <div class="selectedDiv">
        <div class="labelText">{{$t('track.followerModal.selectedFollower')}}</div>
        <div class="followerList">
          <div v-for="(item,index) in followerList" :key="index" class="followerItem">
            <a-avatar :size="45" src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"/>
            <div class="follower_name_row">
              <div class="follower_name">Poer.xu</div>
              <div @click="deleteFollower">
                <pt-icon type="icon-quxiao" class="delIcon"></pt-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <pt-table :data-source="tableList.tableData"  :loading="tableList.tableLoading" :showAdd="false"
                  :total="tableList.pageInfo.total"  @tablePageChange="changeTable">
          <template slot="columns">
            <el-table-column prop="name" :label="$t('track.followerModal.name')" align="left">
              <div slot-scope="scope" class="tableItem">
                <a-avatar :size="35" src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"/>
                <div class="follower_name">Poer.xu</div>
              </div>
            </el-table-column>
            <el-table-column prop="phone" :label="$t('track.followerModal.telephone')" align="center">
              <div slot-scope="scope">13760516689</div>
            </el-table-column>
            <el-table-column prop="select" :label="$t('track.followerModal.select')" align="right">
              <div slot-scope="scope">
                <a-checkbox></a-checkbox>
              </div>
            </el-table-column>
          </template>
        </pt-table>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'addFollower',
    data(){
      return{
        tableList:{
          tableData:[1,2,3,4],
          tableLoading:false,
          pageInfo:{
            total:0,
            pageSize:10,
          }
        },
        followerList:[1,2,3,4],
      }
    },
    methods:{
      deleteFollower(){

      },
      addEvent(){

      },
      changeTable(){

      }
    }
  }
</script>

<style scoped lang="less">
#addFollower{
  .selectedDiv{
    padding: 0 20px 20px 20px;
    border-bottom: 1px solid #E1E1E1;
    .labelText{
      font-size: 12px;
      color: #999999;
    }
  }
  .followerList{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .followerItem{
    margin-top: 20px;
    margin-right: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .follower_name_row{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 5px;
  }
  .follower_name{
    font-size: 14px;
    color: #4D4D4D;
  }
  .delIcon{
    font-size: 10px;
    margin-left: 6px;
    cursor:pointer;
  }
  .tableItem{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
</style>